import React from "react";

import { Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Calendar, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const asideStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      display: "flex",
      flexDirection: "column",
      justifyContent: "start",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

export const TaskAside = () => {
  const classes = asideStyles();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Card className={classes.root}>
        <Calendar date={new Date()} onChange={(date) => null} />
      </Card>
    </MuiPickersUtilsProvider>
  );
};
